import React, { useEffect, useState } from "react";
import {
  Grid,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  Typography,
  Paper,
  Box,
  TextField,
} from "@material-ui/core";
import { useQuery, useMutation } from "@apollo/client";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  getModulesByPaginationQuery,
  updateModuleOrderMutation,
} from "./ModulesGqlQuery";
import ReactDragListView from "react-drag-listview/lib/index.js";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";

const defaultSorted = [
  {
    id: "line_order",
    desc: false,
  },
];

const UpdateModuleOrderDialog = (props) => {
  const [getAllModulesData, setGetAllModulesData] = useState([]);

  const { data: getPlanModulesQuery } = useQuery(getModulesByPaginationQuery, {
    fetchPolicy: "network-only",
    variables: {
      searchtext: null,
      sortedBy: defaultSorted,
      limit: null,
      offset: null,
    },
  });

  useEffect(() => {
    if (
      getPlanModulesQuery &&
      getPlanModulesQuery.modulesByPaginationQuery.modules &&
      getPlanModulesQuery.modulesByPaginationQuery.modules.length > 0
    ) {
      let allModulesData = [
        ...getPlanModulesQuery.modulesByPaginationQuery.modules,
      ]
        .map((qitem) => {
          let item = { ...qitem };
          item.label = item.moduleDisplayName;
          return item;
        });

      setGetAllModulesData(allModulesData);
    }
  }, [getPlanModulesQuery]);

  const [updateModuleOrder] = useMutation(updateModuleOrderMutation);

  const handleSubmit = () => {
    const updatedOrderList = getAllModulesData.map((module, index) => ({
      // ...module,
      id: module.id,
      lineOrder: index + 1,
      moduleDisplayName: module.label || module.moduleDisplayName,
      moduleName: module.moduleName,
    }));
    

    updateModuleOrder({
      variables: {
        modules: updatedOrderList,
      },
    })
      .then(() => {
        if (props.onSuccess) {
          props.onSuccess(updatedOrderList);
        }

        if (props.handleClose) {
          props.handleClose();
        }
      })
      .catch((error) => {
        console.error("Update Module Order Error:", error);
      });
  };

  const dragProps = {
    onDragEnd: function(fromIndex, toIndex) {
      if (fromIndex === toIndex || fromIndex < 0 || toIndex < 0) {
        return;
      }

      setGetAllModulesData(function(previousList) {
        const updatedList = [...previousList];
        const movedItem = updatedList.splice(fromIndex, 1)[0];

        if (!movedItem) {
          return previousList;
        }

        updatedList.splice(toIndex, 0, movedItem);

        return updatedList;
      });
    },

    nodeSelector: ".module-order-row",

    handleSelector: ".drag-handle",
  };

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        handleSubmit();
      }}
    >
      <div style={{ flexDirection: "column", display: "flex" }}>
        <DialogContent
          // className="popoverOverflow"
          style={{
            paddingTop: 0,
            maxHeight: 500,
            overflowY: "auto",
            padding: 0,
          }}
        >
          <ReactDragListView {...dragProps}>
            <Grid
              container
              direction="column"
              spacing={1}
              style={{ marginTop: 4 }}
            >
              {getAllModulesData.map((module, index) => (
                <Grid item xs={12} key={module.id} className="module-order-row">
                 
                  <Paper
                    elevation={0}
                    style={{
                      alignItems: "center",
                      border: "1px solid #e0e0e0",
                      borderRadius: 8,
                      display: "flex",
                      padding: "10px 12px"
                    }}
                  >
                    
                    <Box
                      className="drag-handle"
                      style={{
                        width: 34,
                        height: 38,

                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",

                        color: "#9ca3af",
                        cursor: "grab",
                        flexShrink: 0,
                      }}
                    >
                      <DragIndicatorIcon fontSize="small" />
                    </Box>

                    <Typography
                      style={{
                        alignItems: "center",
                        backgroundColor: "#f5f5f5",
                        borderRadius: "50%",
                        display: "flex",
                        fontWeight: 600,
                        height: 28,
                        justifyContent: "center",
                        marginRight: 12,
                        minWidth: 28,
                      }}
                    >
                      {index + 1}
                    </Typography>
                    <Box>
                     <Typography
                       variant="body2"
                       color="textSecondary"
                      //  style={{marginLeft : 80}}
                     >
                      Module: <strong>{module.moduleName || ""}</strong>
                     </Typography>
                    <TextField
                      value={module.moduleDisplayName || ""}
                      onChange={(event) => {
                        const moduleDisplayName = event.target.value;

                        setGetAllModulesData((previousList) =>
                          previousList.map((item) =>
                            item.id === module.id
                              ? {
                                  ...item,
                                  label: moduleDisplayName,
                                  moduleDisplayName,
                                }
                              : item,
                          ),
                        );
                      }}
                      variant="outlined"
                      size="small"
                      fullWidth
                      inputProps={{ "aria-label": "Module display name" }}
                      style={{ marginRight: 12 }}
                    />
                    </Box>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </ReactDragListView>
        </DialogContent>
        <DialogActions>
          <div
            style={{ flexDirection: "column", display: "flex", width: "100%" }}
          >
            <Divider />

            <div style={{ justifyContent: "flex-end", display: "flex" }}>
              <Button onClick={props.handleClose} color="primary">
                Cancel
              </Button>
              <Button
                type="submit"
                // disabled={getAllModulesData.length === 0}
                color="primary"
              >
                Save
              </Button>
            </div>
          </div>
        </DialogActions>
      </div>
    </form>
  );
};

UpdateModuleOrderDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = () => {
  return {};
};

const styles = (theme) => ({
  lableOutline: {
    zIndex: "9",
    background: "#fff",
    padding: "0px 5px 0px 6px",
    marginLeft: "-5px",
  },
  panel: {
    position: "fixed",
    width: 360,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    top: 0,
    height: "100%",
    minHeight: "100%",
    bottom: 0,
    right: 0,
    margin: 0,
    zIndex: 1000,
    padding: "55px 0px 0px",
    transform: "translate3d(360px,0,0)",
    // overflow: "hidden",
    [theme.breakpoints.down("md")]: {
      transform: "translate3d(360px,0,0)",
      boxShadow: "none",
      "&.opened": {
        boxShadow: theme.shadows[5],
      },
    },
    transition: theme.transitions.create(["transform"], {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.standard,
    }),
    "&.opened": {
      transform: "translateX(0)",
    },
  },
});

export default withStyles(styles)(
  connect(mapStateToProps)(UpdateModuleOrderDialog),
);
